module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-card-wrapper",
    class: {
      'segment-card': _vm.isSegmentCard || _vm.isScreenList
    }
  }, [_c('div', {
    staticClass: "thumb_page tile",
    class: {
      selected: _vm.isSelected,
      segment: _vm.segment,
      'module-list': _vm.isModuleList,
    }
  }, [_c('div', {
    staticClass: "slide tile__media",
    class: [{
      'module-list': _vm.isModuleList
    }],
    style: (_vm.backgroundImageMedia)
  }, [_c('div', {
    ref: "cardEl",
    staticClass: "containerScreen tile__img",
    class: [{
      'module-list': _vm.isModuleList
    }],
    style: ({
      backgroundImage: _vm.backgroundImage
    }),
    on: {
      "click": function($event) {
        return _vm.$emit('selected')
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMultipleLayers),
      expression: "isMultipleLayers"
    }],
    staticClass: "segment-type"
  }, [_c('i', {
    staticClass: "icon-layers"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isModuleList),
      expression: "isModuleList"
    }],
    staticClass: "close-segment",
    on: {
      "click": function($event) {
        return _vm.$emit('remove-segment')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M437.019,74.981C388.668,26.628,324.378,0,256,0C187.62,0,123.333,26.628,74.981,74.98S0,187.62,0,256\n\t\t\tc0,68.381,26.628,132.668,74.981,181.02C123.332,485.372,187.62,512,255.999,512s132.669-26.628,181.02-74.98\n\t\t\tC485.371,388.667,512,324.38,512,256C512,187.619,485.371,123.332,437.019,74.981z M368.853,347.642\n\t\t\tc5.857,5.857,5.857,15.355,0,21.213c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393L256,277.214\n\t\t\tl-91.641,91.641c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393c-5.858-5.857-5.858-15.355,0-21.213\n\t\t\tl91.64-91.641l-91.64-91.641c-5.858-5.857-5.858-15.355,0-21.213c5.857-5.857,15.354-5.857,21.213,0L256,234.788l91.64-91.641\n\t\t\tc5.857-5.857,15.355-5.857,21.213,0c5.857,5.857,5.857,15.355,0,21.213l-91.641,91.641L368.853,347.642z"
    }
  })])]), _vm._v(" "), (!_vm.isModuleList) ? _c('ul', {
    staticClass: "actions-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.checkTarget($event)
      }
    }
  }, [_c('li', {
    staticClass: "fa fa-clone item-li li-duplicate ",
    class: {
      disabled: _vm.selectedSlides.length >= _vm.permission.nb_screen_segment && _vm.getNbSreenSegment,
    },
    attrs: {
      "title": _vm.$t('panels.duplicateScreen')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('duplicated')
      }
    }
  }), _vm._v(" "), _c('v-popover', {
    staticClass: "more-actions-btn-parent p-2",
    attrs: {
      "offset": "16",
      "container": "#editor",
      "popoverClass": "card-tooltip",
      "placement": "top",
      "default-placement": "top"
    }
  }, [_c('li', {
    staticClass: "fa fa-ellipsis-v item-li li-edit more-actions-btn open-menu-style",
    attrs: {
      "title": _vm.$t('panels.editScreen')
    }
  }), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('panel-card-actions', {
    attrs: {
      "is-segment-card": _vm.isSegmentCard,
      "card": _vm.slide,
      "segment": _vm.segment
    }
  })], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (!_vm.isScreenList) ? _c('div', {
    staticClass: "duration-wrapper"
  }, [_vm._v(_vm._s(_vm._f("FormatTime")(_vm.duration)))]) : _vm._e(), _vm._v(" "), (!_vm.isModuleList) ? _c('div', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('can_toggle_slides_action'),
      expression: "'can_toggle_slides_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegmentCard),
      expression: "isSegmentCard"
    }],
    staticClass: "toggle-slides",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSegment($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-arrow-left",
    class: {
      rotated: _vm.isExtended(_vm.slide.uid)
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.isModuleList) ? _c('div', {
    staticClass: "slide_name"
  }, [_c('div', {
    staticClass: "tile__title",
    attrs: {
      "id": _vm.index,
      "title": _vm.$t('panels.edit_title')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.slide.title) + "\n          ")])]) : _vm._e()]), _vm._v(" "), (_vm.isModuleList) ? _c('div', {
    staticClass: "slide_name"
  }, [(_vm.paramsClient.nb_screen_segment !== 1) ? _c('div', {
    staticClass: "tile__title",
    class: [{
      'module-list': _vm.isModuleList
    }],
    attrs: {
      "id": _vm.index,
      "title": _vm.$t('panels.edit_title')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.slide.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1 && _vm.slide.screens) ? _c('div', {
    staticClass: "tile__title",
    class: [{
      'module-list': _vm.isModuleList
    }],
    attrs: {
      "id": _vm.index,
      "title": _vm.$t('panels.edit_title')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.slide.screens[0].title) + "\n        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.isModuleList) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegmentCard),
      expression: "isSegmentCard"
    }],
    staticClass: "btn btn-sm add-segment-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('insertSegment')
      }
    }
  }, [_vm._v("\n      + Segment\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5542424c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/PanelCard.vue
// module id = 836
// module chunks = 1 3